import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { useHistory } from "react-router";
import {
  Container,
  Grid,
  TextField,
  Button,
  FormGroup,
  FormControlLabel,
  Input,
  Checkbox,
  ListItemText,
  MenuItem,
} from "@material-ui/core";
import {
  Autocomplete,
  Box,
  FormControl,
  InputLabel,
  Select,
} from "@mui/material";
import { userAPI } from "./../services/UserService";
import { workAPI } from "./../services/WorkService";
import { Formik, Form } from "formik";
import * as Yup from "yup";

const Setting_Edit_User = () => {
  const [role, setRole] = useState(null);
  const [AllUser, setAllUser] = useState([]);
  const [BuyerUser, setBuyerUser] = useState([]);
  const [TypeUser, setTypeUser] = useState([]);
  const [permission, setPermission] = useState({
    view_work: false,
    add_work: false,
    get_work: false,
    view_report: false,
    view_promotion: false,
    manage_user: false,
    manage_type: false,
    manage_template: false,
    manage_product: false,
    view_set_price: false,
    excel_set_price: false,
    manage_group_bu: false,
    view_min_day: false,
  });
  let history = useHistory();
  const FormSchema = Yup.object().shape({
    username: Yup.string().trim().required("*ชื่อห้ามว่าง"),
    password: Yup.string().trim().required("*ชื่อห้ามว่าง"),
    fullname: Yup.string().trim().required("*ชื่อห้ามว่าง"),
    PositionName: Yup.string().trim().required("*ชื่อตำแหน่งห้ามว่าง"),
    Email: Yup.string().trim(),
  });

  const addUnderBuyer = (e) => {
    let username = e.target.value;
    setBuyerUser(username);
  };

  const changeFullname = (name) => {
    if (Array.isArray(name)) {
      let findFullname = name.map((res) => {
        const fucking = AllUser.find((rez) => rez.username == res);
        return fucking ? fucking.fullname : res;
      });

      return findFullname;
    } else return name;
  };

  useEffect(() => {
    if (role && role == "Buyer" && AllUser.length == 0) {
      userAPI
        .getUserRetail()
        .then((res) => {
          if (res.status == 200 && res.message instanceof Array) {
            setAllUser(res.message);
          } else {
            alert(res.message);
          }
        })
        .catch((error) => {
          alert(error.message);
        });
    }
  }, [role]);

  const [type, setType] = useState([]);

  useEffect(() => {
    const token = localStorage.getItem("Token");
    workAPI
      .GetType(token)
      .then((res) => {
        if (res.status == 200) {
          if (Array.isArray(res.message)) {
            setType(res.message);
          }
        } else throw new Error(String(res.message));
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          confirmButtonColor: "#f27474",
          html: `<span class="colorWhite">${error.message}</span>`,
          backdrop: "transparent",
          background: "rgba(0,0,0,.75)",
          customClass: {
            icon: "switch",
          },
          width: "28rem",
          timer: 10000,
        });
      });
  }, []);

  return (
    <Formik
      validationSchema={FormSchema}
      initialValues={{
        fullname: "",
        username: "",
        password: "",
        PositionName: "",
        Email: "",
        nickname: "",
        table: "",
      }}
      onSubmit={async (values, { setSubmitting }) => {
        try {
          if (permission.view_work && !values.role)
            throw { message: "กรุณาเลือก Role ในการดูหน้า Messenger" };
          Swal.fire({
            title: "คุณแน่ใจ ?",
            text: "คุณยืนยันที่จะเพิ่ม User " + values.username + " " + "?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#56A834",
            cancelButtonColor: "#d33",
            confirmButtonText: "แน่ใจ",
            cancelButtonText: "ยังก่อน",
          }).then((result) => {
            try {
              if (result.isConfirmed) {
                setSubmitting(true);
                let form = new FormData();
                if (
                  values.Email &&
                  !String(values.Email)
                    .toLowerCase()
                    .match(
                      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    )
                )
                  throw { message: "รูปแบบ Email ไม่ถูกต้อง" };
                if (values.Email) {
                  form.append("Email", values.Email);
                }
                form.append("username", values.username);
                form.append("password", values.password);
                form.append("fullname", values.fullname);
                form.append("PositionName", values.PositionName);
                form.append("nickname", values.nickname);
                form.append("table", values.table);
                form.append("role", values.role || "User");
                form.append("permission", JSON.stringify(permission));
                if (values.role == "Buyer") {
                  form.append("buyerunder", JSON.stringify(BuyerUser));
                }
                form.append("type", JSON.stringify(TypeUser));
                if (values.Email) {
                  const checkEmail = String(values.Email)
                    .toLowerCase()
                    .match(
                      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    );
                  if (!checkEmail) throw { message: "รูปแบบ Email ไม่ถูกต้อง" };
                  form.append("Email", values.Email);
                }
                userAPI
                  .Register(form)
                  .then((res) => {
                    if (res.status == 200) {
                      Swal.fire({
                        icon: "success",
                        confirmButtonColor: "#6ab23a",
                        html: `<span class="colorWhite">เพิ่ม ${values.username} เรียบร้อยแล้ว</span>`,
                        backdrop: "transparent",
                        background: "rgba(0,0,0,.75)",
                        customClass: {
                          icon: "switchZ",
                        },
                        width: "28rem",
                        timer: 3000,
                      }).then((res) => {
                        setSubmitting(false);
                        history.push("/settings/user");
                      });
                    } else {
                      setSubmitting(false);
                      Swal.fire({
                        icon: "error",
                        confirmButtonColor: "#f27474",
                        html: `<span class="colorWhite">${res.message}</span>`,
                        backdrop: "transparent",
                        background: "rgba(0,0,0,.75)",
                        customClass: {
                          icon: "switch",
                        },
                        width: "28rem",
                        timer: 3000,
                      });
                    }
                  })
                  .catch((error) => {
                    setSubmitting(false);
                    Swal.fire({
                      icon: "error",
                      confirmButtonColor: "#f27474",
                      html: `<span class="colorWhite">${error.message}</span>`,
                      backdrop: "transparent",
                      background: "rgba(0,0,0,.75)",
                      customClass: {
                        icon: "switch",
                      },
                      width: "28rem",
                      timer: 3000,
                    });
                  });
              }
            } catch (error) {
              setSubmitting(false);
              Swal.fire({
                icon: "error",
                confirmButtonColor: "#f27474",
                html: `<span class="colorWhite">${error.message}</span>`,
                backdrop: "transparent",
                background: "rgba(0,0,0,.75)",
                customClass: {
                  icon: "switch",
                },
                width: "28rem",
                timer: 3000,
              });
            }
          });
        } catch (error) {
          setSubmitting(false);
          Swal.fire({
            icon: "error",
            confirmButtonColor: "#f27474",
            html: `<span class="colorWhite">${error.message}</span>`,
            backdrop: "transparent",
            background: "rgba(0,0,0,.75)",
            customClass: {
              icon: "switch",
            },
            width: "28rem",
            timer: 3000,
          });
        }
      }}
    >
      {({
        values,
        handleChange,
        setFieldValue,
        isSubmitting,
        touched,
        errors,
      }) => (
        <Form>
          <Container
            style={{
              padding: "20px",
              backgroundColor: "#ffffffbd",
              borderRadius: "10px",
            }}
          >
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <h3>
                  <strong>เพิ่มข้อมูล User</strong>
                </h3>
              </Grid>
            </Grid>
            <Container style={{ paddingTop: "1rem" }}>
              <div className="row">
                <div className="pt-5 col-lg-12">
                  <div className="row">
                    <div className="mt-4 col-lg-12">
                      <TextField
                        style={{ width: "100%" }}
                        name="username"
                        value={values.username}
                        label="Username..."
                        onChange={handleChange}
                      />
                      {errors.username && touched.username ? (
                        <div style={{ color: "#FF3333" }}>
                          {errors.username}
                        </div>
                      ) : null}
                    </div>
                    <div className="mt-4 col-lg-12">
                      <TextField
                        style={{ width: "100%" }}
                        name="password"
                        value={values.password}
                        label="Password..."
                        onChange={handleChange}
                        type="password"
                      />
                      {errors.password && touched.password ? (
                        <div style={{ color: "#FF3333" }}>
                          {errors.password}
                        </div>
                      ) : null}
                    </div>
                    <div className="mt-4 col-lg-12">
                      <TextField
                        style={{ width: "100%" }}
                        name="fullname"
                        value={values.fullname}
                        label="ชื่อ นามสกุล..."
                        onChange={handleChange}
                      />
                      {errors.fullname && touched.fullname ? (
                        <div style={{ color: "#FF3333" }}>
                          {errors.fullname}
                        </div>
                      ) : null}
                    </div>
                    <div className="mt-4 col-lg-12">
                      <TextField
                        name="nickname"
                        onChange={handleChange}
                        style={{ width: "100%" }}
                        value={values.nickname}
                        label="ชื่อเล่น..."
                      />
                      {errors.nickname && touched.nickname ? (
                        <div style={{ color: "#FF3333" }}>
                          {errors.nickname}
                        </div>
                      ) : null}
                    </div>
                    <div className="mt-4 col-lg-12">
                      <TextField
                        name="table"
                        onChange={handleChange}
                        style={{ width: "100%" }}
                        value={values.table}
                        label="เบอร์โต๊ะ..."
                      />
                      {errors.table && touched.table ? (
                        <div style={{ color: "#FF3333" }}>{errors.table}</div>
                      ) : null}
                    </div>
                    <div className="mt-4 col-lg-12">
                      <TextField
                        name="Email"
                        onChange={handleChange}
                        style={{ width: "100%" }}
                        value={values.Email}
                        label="Email..."
                        type="email"
                      />
                      {errors.Email && touched.Email ? (
                        <div style={{ color: "#FF3333" }}>{errors.Email}</div>
                      ) : null}
                    </div>
                    <div className="mt-4 col-lg-12">
                      <TextField
                        name="PositionName"
                        style={{ width: "100%" }}
                        value={values.PositionName}
                        label="ชื่อตำแหน่ง..."
                        onChange={handleChange}
                      />
                      {errors.PositionName && touched.PositionName ? (
                        <div style={{ color: "#FF3333" }}>
                          {errors.PositionName}
                        </div>
                      ) : null}
                    </div>
                    {permission.view_work && (
                      <div className="mt-4 col-12">
                        <label>
                          <strong>User Role</strong>
                        </label>
                        <Autocomplete
                          name="role"
                          options={["Retail", "Support", "Buyer", "Admin"]}
                          onChange={(event, newValue) => {
                            setFieldValue("role", newValue);
                            setRole(newValue);
                          }}
                          value={values.role}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              name="role"
                              variant="standard"
                              value={values?.role || ""}
                            />
                          )}
                        />
                      </div>
                    )}
                    {values.role == "Buyer" && (
                      <div className="mt-4 col-12">
                        <InputLabel>
                          <strong>Retail Merchandiser</strong>
                        </InputLabel>
                        <FormControl style={{ width: "100%" }}>
                          <Select
                            multiple
                            value={BuyerUser}
                            onChange={addUnderBuyer}
                            input={<Input />}
                            renderValue={(selected) =>
                              changeFullname(selected).join(", ")
                            }
                          >
                            {AllUser.map((res) => (
                              <MenuItem key={res.username} value={res.username}>
                                <Checkbox
                                  checked={
                                    BuyerUser.find((rez) => rez == res.username)
                                      ? true
                                      : false
                                  }
                                />
                                <ListItemText primary={res.fullname} />
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </div>
                    )}
                    <Box display={"flex"}>
                      <div className="mt-4 col-4">
                        <div className="mt-4 col-12">
                          <label>
                            <strong>ดูงาน</strong>
                          </label>
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={!!permission.view_work}
                                  onClick={() =>
                                    setPermission((old) => ({
                                      ...old,
                                      view_work: true,
                                    }))
                                  }
                                />
                              }
                              label="ทำได้"
                            />
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={!permission.view_work}
                                  onClick={() =>
                                    setPermission((old) => ({
                                      ...old,
                                      view_work: false,
                                    }))
                                  }
                                />
                              }
                              label="ทำไม่ได้"
                            />
                          </FormGroup>
                        </div>
                      </div>
                      <div className="mt-4 col-4">
                        <div className="mt-4 col-12">
                          <label>
                            <strong>สร้างงาน</strong>
                          </label>
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={!!permission.add_work}
                                  onClick={() =>
                                    setPermission((old) => ({
                                      ...old,
                                      add_work: true,
                                    }))
                                  }
                                />
                              }
                              label="ทำได้"
                            />
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={!permission.add_work}
                                  onClick={() =>
                                    setPermission((old) => ({
                                      ...old,
                                      add_work: false,
                                    }))
                                  }
                                />
                              }
                              label="ทำไม่ได้"
                            />
                          </FormGroup>
                        </div>
                      </div>
                      <div className="mt-4 col-4">
                        <div className="mt-4 col-12">
                          <label>
                            <strong>รับงาน</strong>
                          </label>
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={!!permission.get_work}
                                  onClick={() =>
                                    setPermission((old) => ({
                                      ...old,
                                      get_work: true,
                                    }))
                                  }
                                />
                              }
                              label="ทำได้"
                            />
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={!permission.get_work}
                                  onClick={() =>
                                    setPermission((old) => ({
                                      ...old,
                                      get_work: false,
                                    }))
                                  }
                                />
                              }
                              label="ทำไม่ได้"
                            />
                          </FormGroup>
                        </div>
                      </div>
                    </Box>
                    <Box display={"flex"}>
                      <div className="mt-4 col-4">
                        <div className="mt-4 col-12">
                          <label>
                            <strong>จัดการประเภทงาน</strong>
                          </label>
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={!!permission.manage_type}
                                  onClick={() =>
                                    setPermission((old) => ({
                                      ...old,
                                      manage_type: true,
                                    }))
                                  }
                                />
                              }
                              label="ทำได้"
                            />
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={!permission.manage_type}
                                  onClick={() =>
                                    setPermission((old) => ({
                                      ...old,
                                      manage_type: false,
                                    }))
                                  }
                                />
                              }
                              label="ทำไม่ได้"
                            />
                          </FormGroup>
                        </div>
                      </div>
                      <div className="mt-4 col-4">
                        <div className="mt-4 col-12">
                          <label>
                            <strong>จัดการไฟล์ Template</strong>
                          </label>
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={!!permission.manage_template}
                                  onClick={() =>
                                    setPermission((old) => ({
                                      ...old,
                                      manage_template: true,
                                    }))
                                  }
                                />
                              }
                              label="ทำได้"
                            />
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={!permission.manage_template}
                                  onClick={() =>
                                    setPermission((old) => ({
                                      ...old,
                                      manage_template: false,
                                    }))
                                  }
                                />
                              }
                              label="ทำไม่ได้"
                            />
                          </FormGroup>
                        </div>
                      </div>
                      <div className="mt-4 col-4">
                        <div className="mt-4 col-12">
                          <label>
                            <strong>จัดการข้อมูล User</strong>
                          </label>
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={!!permission.manage_user}
                                  onClick={() =>
                                    setPermission((old) => ({
                                      ...old,
                                      manage_user: true,
                                    }))
                                  }
                                />
                              }
                              label="ทำได้"
                            />
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={!permission.manage_user}
                                  onClick={() =>
                                    setPermission((old) => ({
                                      ...old,
                                      manage_user: false,
                                    }))
                                  }
                                />
                              }
                              label="ทำไม่ได้"
                            />
                          </FormGroup>
                        </div>
                      </div>
                    </Box>
                    <Box display={"flex"}>
                      <div className="mt-4 col-4">
                        <div className="mt-4 col-12">
                          <label>
                            <strong>จัดการข้อมูล Product</strong>
                          </label>
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={!!permission.manage_product}
                                  onClick={() =>
                                    setPermission((old) => ({
                                      ...old,
                                      manage_product: true,
                                    }))
                                  }
                                />
                              }
                              label="ทำได้"
                            />
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={!permission.manage_product}
                                  onClick={() =>
                                    setPermission((old) => ({
                                      ...old,
                                      manage_product: false,
                                    }))
                                  }
                                />
                              }
                              label="ทำไม่ได้"
                            />
                          </FormGroup>
                        </div>
                      </div>
                      <div className="mt-4 col-4">
                        <div className="mt-4 col-12">
                          <label>
                            <strong>ดู Report ส่งงาน</strong>
                          </label>
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={!!permission.view_report}
                                  onClick={() =>
                                    setPermission((old) => ({
                                      ...old,
                                      view_report: true,
                                    }))
                                  }
                                />
                              }
                              label="ทำได้"
                            />
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={!permission.view_report}
                                  onClick={() =>
                                    setPermission((old) => ({
                                      ...old,
                                      view_report: false,
                                    }))
                                  }
                                />
                              }
                              label="ทำไม่ได้"
                            />
                          </FormGroup>
                        </div>
                      </div>
                      <div className="mt-4 col-4">
                        <div className="mt-4 col-12">
                          <label>
                            <strong>ดู Promotion</strong>
                          </label>
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={!!permission.view_promotion}
                                  onClick={() =>
                                    setPermission((old) => ({
                                      ...old,
                                      view_promotion: true,
                                    }))
                                  }
                                />
                              }
                              label="ทำได้"
                            />
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={!permission.view_promotion}
                                  onClick={() =>
                                    setPermission((old) => ({
                                      ...old,
                                      view_promotion: false,
                                    }))
                                  }
                                />
                              }
                              label="ทำไม่ได้"
                            />
                          </FormGroup>
                        </div>
                      </div>
                    </Box>
                    <Box display={"flex"}>
                      <div className="mt-4 col-4">
                        <div className="mt-4 col-12">
                          <label>
                            <strong>ดู Set Price</strong>
                          </label>
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={!!permission.view_set_price}
                                  onClick={() =>
                                    setPermission((old) => ({
                                      ...old,
                                      view_set_price: true,
                                    }))
                                  }
                                />
                              }
                              label="ทำได้"
                            />
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={!permission.view_set_price}
                                  onClick={() =>
                                    setPermission((old) => ({
                                      ...old,
                                      view_set_price: false,
                                    }))
                                  }
                                />
                              }
                              label="ทำไม่ได้"
                            />
                          </FormGroup>
                        </div>
                      </div>
                      <div className="mt-4 col-4">
                        <div className="mt-4 col-12">
                          <label>
                            <strong>Excel Set Price</strong>
                          </label>
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={!!permission.excel_set_price}
                                  onClick={() =>
                                    setPermission((old) => ({
                                      ...old,
                                      excel_set_price: true,
                                    }))
                                  }
                                />
                              }
                              label="ทำได้"
                            />
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={!permission.excel_set_price}
                                  onClick={() =>
                                    setPermission((old) => ({
                                      ...old,
                                      excel_set_price: false,
                                    }))
                                  }
                                />
                              }
                              label="ทำไม่ได้"
                            />
                          </FormGroup>
                        </div>
                      </div>
                      <div className="mt-4 col-4">
                        <div className="mt-4 col-12">
                          <label>
                            <strong>จัดการข้อมูล Group Bu (Set Price)</strong>
                          </label>
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={!!permission.manage_group_bu}
                                  onClick={() =>
                                    setPermission((old) => ({
                                      ...old,
                                      manage_group_bu: true,
                                    }))
                                  }
                                />
                              }
                              label="ทำได้"
                            />
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={!permission.manage_group_bu}
                                  onClick={() =>
                                    setPermission((old) => ({
                                      ...old,
                                      manage_group_bu: false,
                                    }))
                                  }
                                />
                              }
                              label="ทำไม่ได้"
                            />
                          </FormGroup>
                        </div>
                      </div>
                    </Box>
                    <Box display={"flex"}>
                      <div className="mt-4 col-4">
                        <div className="mt-4 col-12">
                          <label>
                            <strong>ดู Min/Day</strong>
                          </label>
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={!!permission.view_min_day}
                                  onClick={() =>
                                    setPermission((old) => ({
                                      ...old,
                                      view_min_day: true,
                                    }))
                                  }
                                />
                              }
                              label="ทำได้"
                            />
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={!permission.view_min_day}
                                  onClick={() =>
                                    setPermission((old) => ({
                                      ...old,
                                      view_min_day: false,
                                    }))
                                  }
                                />
                              }
                              label="ทำไม่ได้"
                            />
                          </FormGroup>
                        </div>
                      </div>
                    </Box>

                    <div className="mt-4 col-4">
                      <div className="mt-4 col-12">
                        <label>
                          <strong>
                            Type Create Work *ถ้าไม่เลือกจะเห็นทั้งหมด
                          </strong>
                        </label>
                      </div>
                    </div>

                    <div className="mt-4 col-12">
                      <FormControl style={{ width: "100%" }}>
                        <Select
                          multiple
                          value={TypeUser}
                          onChange={(e) => setTypeUser(e.target.value)}
                          input={<Input />}
                          renderValue={(selected) =>
                            changeFullname(selected).join(", ")
                          }
                        >
                          {type.map((res) => (
                            <MenuItem
                              key={`${res.type_name}-key-type_`}
                              value={res.type_name}
                            >
                              <Checkbox
                                checked={
                                  TypeUser.find((rez) => rez == res.type_name)
                                    ? true
                                    : false
                                }
                              />
                              <ListItemText primary={res.type_name} />
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>

                    <div className="mt-4 col-12">
                      <Button
                        variant="contained"
                        type="submit"
                        disabled={isSubmitting}
                        style={{
                          border: "2px solid transparent",
                          backgroundColor: "#6ab23a",
                          borderRadius: "5px",
                          color: "white",
                          fontSize: "16px",
                          textDecoration: "none",
                          textTransform: "capitalize",
                        }}
                      >
                        Submit
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </Container>
          </Container>
        </Form>
      )}
    </Formik>
  );
};

export default Setting_Edit_User;
